export const API_URL = process.env.REACT_APP_API_URL || "";

// 공통
export const COMMON_API_ROUTES = {
    // 게시판 --------------------
    BOARD_LIST: "/api/board/:category/:limit",
    BOARD_DETAIL: "/api/board/view/:category/:idx",
    BOARD_FILE_DOWNLOAD: "/api/board/download/:category/:parent_idx/:idx",
};

// 사용자
export const USER_API_ROUTES = {
    // 팝업 --------------------
    POPUP_LIST: "/api/auth/popup/",
    POPUP_DETAIL: "/api/auth/popup/:idx",

    // 문의사항 --------------------
    CONTACT_FORM: "/api/auth/form",

    // 인스타그램 --------------------
    INSTAGRAM_LIST: "/api/instagram/list",
};

// 관리자
export const CONSOLE_API_ROUTES = {
    // 로그인 --------------------
    LOGIN: "/api/auth/login",

    // 게시판 관리 --------------------
    BOARD_MANAGE: "/api/board/",
    BOARD_NOTICE: "/api/board/notice",
    BOARD_STATE: "/api/board/open",
    BOARD_FILE: "/api/board/file",
    BOARD_MOVE_ORDER: "/api/board/moveOrder",

    // 팝업 관리 --------------------
    POPUP: "/api/admin/popup",
    POPUP_STATE: "/api/admin/popup/open",
    POPUP_DETAIL: "/api/admin/popup/:idx",
};
